import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
        marginTop: 20,
        maxWidth: 570,
        width: '100%',
        marginHorizontal: 'auto'
    },
});

export default styles;
